import React from "react";
import { Drawer, IconButton, Tooltip } from "@mui/material";
import { RiArrowLeftLine } from "@remixicon/react";
import SidebarItem from "./SidebarItem";

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onClose }) => {
  return (
    <Drawer
      variant="persistent"
      open={isOpen}
      onClose={onClose}
      className="sidebar-drawer"
    >
      <div className="sidebar-header">
        <Tooltip title="Collapse menu">
          <IconButton onClick={onClose}>
            <RiArrowLeftLine style={{ color: "var(--color-light-gray)" }} />
          </IconButton>
        </Tooltip>
      </div>
      <div className="sidebar-content">
        <SidebarItem
          id="customers"
          topLevelLink="/customers"
          topLevelLabel="Customer Management"
          expandable={true}
          subItems={[
            { label: "Customers", link: "/customers" },
            { label: "Deliveries", link: "/deliveries" },
            { label: "Samples", link: "/samples" }
          ]}
          defaultExpanded={true}
        />
        <SidebarItem
          id="shipping"
          topLevelLink="/shipping/weekly"
          topLevelLabel="Shipping Operations"
          expandable={true}
          subItems={[
            { label: "Weekly", link: "/shipping/weekly" },
            { label: "Schedule", link: "/schedule/summary" },
            { label: "Deliveries", link: "/schedule/deliveries" },
          ]}
          defaultExpanded={true}
        />
        <SidebarItem
          id="data-ops"
          topLevelLink="/data-ops"
          topLevelLabel="Data Operations"
          expandable={true}
          subItems={[
            {label: "Analysis Reports", link: "/data-ops/analysis-reports"},
            {label: "Compliance", link: "/customer-schemas"},
            {label: "Export Jobs", link: "/data-ops/export-jobs"},
            { label: "Brands", link: "/data-ops/brands" },            
            // { label: "Brands Health", link: "/data-ops/brands-health" },
            { label: "Store Locators", link: "/data-ops/omnis" },
            { label: "Tasks", link: "/data-ops/tasks" },
          ]}
          defaultExpanded={true}
        />
        <SidebarItem
          id="insights"
          topLevelLink="/insights"
          topLevelLabel="Executive Insights"
          expandable={true}
          subItems={[
            { label: "Shipping", link: "/insights/shipping" },
            { label: "Brands", link: "/insights/brands" },
            { label: "Samples", link: "/insights/samples" },
          ]}
          defaultExpanded={true}
        />
      </div>
    </Drawer>
  );
};

export default Sidebar;
